module.exports = __webpack_public_path__ + "static/media/2.54f4f877.jpg";